/* globals MICROFRONTEND_NAME */
/* eslint-disable global-require */
import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'

import FronthubError from '../../../core/helpers/FronthubError'
import rootComponentFactory from '../../../common/microfrontend/react/components/root-component-factory'
import instancePublicApi from '../../../common/microfrontend/react/context-hub-api'

export default function productionHub(Component, fronthubContext, addon) {
  const configuration = fronthubContext.configuration
  const instance = {
    listeners: {},
    delegates: {},
    deferredDelegates: {},
    configuration,
    manifestInstance: fronthubContext.manifestInstance,
  }
  const RootComponent = rootComponentFactory(instance, Component, Router, addon)
  const publicApi = instancePublicApi(instance)
  let actualDOMElement

  return {
    ...publicApi,
    renderAt(DOMElement, params = {}) {
      actualDOMElement =
        typeof DOMElement === 'string'
          ? document.querySelector(DOMElement)
          : DOMElement
      if (actualDOMElement) {
        actualDOMElement.setAttribute('data-front-hub', MICROFRONTEND_NAME)
        actualDOMElement['front-hub'] = { configuration }
        ReactDOM.render(<RootComponent params={params} />, actualDOMElement)
      } else {
        throw new FronthubError(
          `ops... there is something wrong with the DOMElement ` +
            `you passed to render your application: \n "${actualDOMElement}"\n\n`,
        )
      }
    },
    unmount() {
      return ReactDOM.unmountComponentAtNode(actualDOMElement)
    },
  }
}
